import { useEffect } from "react"
import { getReadCookie, getLatestRelease, setReadCookie } from "execCookie"
import useInformation from "hooks/useInformation"

const InformationWrapper = () => {
  const { storeInformation, information } = useInformation()
  const { readReleaseVer, latestReleaseVer } = information

  useEffect(() => {
    storeInformation({
      readReleaseVer: getReadCookie(),
      latestReleaseVer: getLatestRelease(),
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const isRead = readReleaseVer >= latestReleaseVer
    // 既読の場合、cookie有効期限を更新
    isRead && setReadCookie(latestReleaseVer)

    storeInformation({
      isRead: isRead,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latestReleaseVer, readReleaseVer])

  return null
}

export default InformationWrapper
